<template>
	<v-form @submit.prevent="submitForm" ref="formRef" class="d-flex flex-column align-center ga-3 ga-sm-5">
		<ErrorMessage :errorMessage="state.errorMessage" />

		<CustomInput label="First Name" placeholder="Enter your First Name" v-model="state.firstName"
			:error-messages="v$.firstName.$errors.map((e) => e.$message)" @blur="v$.firstName.$touch()" />

		<CustomInput label="Last Name" placeholder="Enter your Last Name" v-model="state.lastName"
			:error-messages="v$.lastName.$errors.map((e) => e.$message)" @blur="v$.lastName.$touch()" />

		<CustomInput label="Email" placeholder="Type your Email" v-model="state.email"
			:error-messages="v$.email.$errors.map((e) => e.$message)" @blur="v$.email.$touch()" />

		<CustomTextArea label="Message" placeholder="Type your message" v-model="state.message"
			:error-messages="v$.message.$errors.map((e) => e.$message)" @blur="v$.message.$touch()" />

		<div class="captcha-container d-flex justify-center align-center align-self-start rounded-8 overflow-hidden">
			<div id="recaptcha" class="recaptcha" data-theme="dark"></div>
		</div>

		<button type="submit" :disabled="loading" class="button--primary rounded-pill px-16 py-3">
			<span class="button-auth__text">{{ loading ? "Submitting..." : "Submit" }}</span>
		</button>
	</v-form>
</template>



<script setup>
/* global grecaptcha */

import log from "loglevel";
import { AppConfigs } from '@/app.configs.ts';
import { useSnackbar } from "@/composables/useSnackbar.ts";
import useVuelidate from "@vuelidate/core";
import { contactUsRules } from "@/utils/ValidationRules";
import CustomInput from "@/components/Common/CustomInput.vue";
import { reactive, ref, onMounted, nextTick, inject } from "vue";
import CustomTextArea from '@/components/Common/CustomTextArea.vue';
import { SupportService } from "@/api/services/SupportService.ts";
import ErrorMessage from "@/components/Auth/Common/Messeges/ErrorMessage.vue";

const state = reactive({
	firstName: "",
	lastName: "",
	email: "",
	message: "",
	errorMessage: "",
});

const v$ = useVuelidate(contactUsRules, state);
const loading = ref(false);
const formRef = ref(null);
const openDialog = inject("openDialog");
const { showSnackbar } = useSnackbar();
const isRecaptchaCompleted = ref(false);

onMounted(() => {
	nextTick(() => {
		if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
			grecaptcha.render('recaptcha', {
				'sitekey': AppConfigs.googleReCaptchaSiteKey,
				'callback': () => {
					isRecaptchaCompleted.value = true;
				},
			});
		} else {
			log.error('grecaptcha is not defined');
		}
	});
});

const submitForm = async () => {
	state.errorMessage = "";
	v$.value.$touch();
	
	if (v$.value.$invalid) {
		state.errorMessage = "Please fill in all required fields correctly.";
		return;
	}

	if (!isRecaptchaCompleted.value) {
		state.errorMessage = "Please complete the reCAPTCHA.";
		return;
	}

	try {
		loading.value = true;
		const captchaResponse = grecaptcha.getResponse();

		await SupportService.contactUsDetails({
			firstName: state.firstName,
			lastName: state.lastName,
			email: state.email,
			message: state.message,
			captcha: captchaResponse
		});

		showSnackbar({
			message: "Form submitted successfully!",
			color: "info",
		});

		// Reset form
		state.firstName = "";
		state.lastName = "";
		state.email = "";
		state.message = "";
		
		setTimeout(() => {
			openDialog.value = false;
		}, 1000);

	} catch (error) {
		state.errorMessage = "Something went wrong. Please try again.";
		showSnackbar({
			message: "Something went wrong!",
			color: "error",
		});
	} finally {
		loading.value = false;
		grecaptcha.reset();
		isRecaptchaCompleted.value = false;
	}
};
</script>